import { createContext } from 'react'

const ScrollToolbarContext = createContext({
  vertical: false,
  mainDimension: 0 //Vertical: ancho  Horizontal:alto
})
export { ScrollToolbarContext }
